import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'

export const CalendarDay = ({ dayInfo, isToday }) => {
  const isWeekend = dayInfo.date.getDay() === 0 || dayInfo.date.getDay() === 6
  const isWorkday = dayInfo.workdayIndex !== null

  // Definir opacidade: dias úteis sempre têm opacidade total
  let opacity = 1
  if (!isWorkday) {
    if (!dayInfo.isCurrentMonth) {
      opacity = 0.3
    } else if (isWeekend) {
      opacity = 0.5
    }
  }

  return (
    <Box width={{ base: '40px', md: '49px' }} height={{ base: '40px', md: '49px' }} borderRadius="md" position="relative" opacity={opacity}>
      <Flex direction="column" alignItems="center" justifyContent="center" height="100%" width="100%" position="relative">
        {isWorkday && (
          <Box
            position="absolute"
            top="2px"
            right="2px"
            borderRadius="sm"
            bg="#37F091"
            px={1}
            fontSize={{ base: '8px', md: '10px' }}
            fontWeight="bold"
            zIndex="1"
          >
            {dayInfo.workdayIndex + 1}º
          </Box>
        )}

        <Flex
          alignItems="center"
          justifyContent="center"
          borderRadius={isToday ? 'full' : 'none'}
          bg={isToday ? '#3D3D3D' : 'transparent'}
          width={{ base: '30px', md: '36px' }}
          height={{ base: '30px', md: '36px' }}
        >
          <Text fontSize={{ base: 'xs', md: 'md' }} fontWeight={isToday ? 'bold' : 'normal'} color={isToday ? '#37F091' : '#3D3D3D'}>
            {dayInfo.date.getDate()}
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}
